import { render, staticRenderFns } from "./InfoMessageDeleteModal.vue?vue&type=template&id=368513fb&scoped=true"
import script from "./InfoMessageDeleteModal.vue?vue&type=script&lang=js"
export * from "./InfoMessageDeleteModal.vue?vue&type=script&lang=js"
import style0 from "./InfoMessageDeleteModal.vue?vue&type=style&index=0&id=368513fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368513fb",
  null
  
)

export default component.exports